import { graphql } from "react-relay";

export const CREATE_MANUAL_ORDER_MODAL = graphql`
	mutation upsertManualOrderModal_UpsertManualOrderModalMutation(
		$input: CreateManualOrderInput!
		$connections: [ID!]!
	) {
		Admin {
			Billing {
				createManualOrder(input: $input) {
					manualOrder @appendEdge(connections: $connections) {
						node {
							...manualOrdersTable_ManualOrderFragment
						}
					}
				}
			}
		}
	}
`;

export const CALCULATE_MANUAL_ORDER_PRICE = graphql`
	mutation upsertManualOrderModal_CalculateManualOrderPriceMutation(
		$input: CalculatePriceForManualOrderInput!
	) {
		Admin {
			Billing {
				calculatePriceForManualOrder(input: $input) {
					price {
						grossPrice
						netPrice
						taxRatePercentage
					}
				}
			}
		}
	}
`;
